// handlers.js
// Trigger global event handlers.
import _ from '../../shared/utils/dont-need-lodash.js';
import {
  SCROLL,
  CLICK,
  TOUCHMOVE,
  PAGE_LOADED,
} from '../../shared/enums/events.js';
import {EventPubSub} from './utils/pubSub.js';

export default function () {
  // Global Events
  // Add global event handlers to the document that can be used
  // by components. Use `radio` and the $target param to target
  // elements.
  document.addEventListener('click', (event, options) => {
    EventPubSub.publish(CLICK, {event, $target: event.target, options});
  });
  
  document.addEventListener('touchmove', (event, options) => EventPubSub.publish(TOUCHMOVE, {event, $target: event.target, options}));
  window.addEventListener('load', (event, options) => EventPubSub.publish(PAGE_LOADED, {event, $target: event.target, options}));

  document.addEventListener('scroll', _.throttle(() => EventPubSub.publish(SCROLL, {}),
    200));
}
